export default {
  /**
   *
   * @param state
   * @param property
   * @param payload
   */
  setProperty(state, { property, payload }) {
    state[property] = payload;
  },

  /**
   *
   * @param state
   * @param filter
   * @param payload
   */
  setFilters(state, { filter, payload }) {
    if (!state.customers_filter[filter]) {
      state.customers_filter = { ...state.customers_filter, ...{ [filter]: payload } };
    } else {
      state.customers_filter[filter] = payload;
    }
  },
};
